module.exports = __webpack_public_path__ + "img/9788954427494.6c3dfa35.jpg";